import { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      
      {/* Logo for all devices */}
      <div 
        className="homepage-logo"
        style={{
          position: 'relative',
          width: '100%',
          textAlign: 'center',
          marginTop: '20px',
          marginBottom: '20px'
        }}
      >
        <img 
          src="/assets/logo-v6e.png" 
          alt="Logo" 
          className="logo-image"
          style={{
            maxWidth: '500px',
            height: 'auto',
            display: 'block',
            margin: '0 auto'
          }}
        />
      </div>
      
      <GameList />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
      
      <style>{`
        @media (max-width: 768px) {
          .logo-image {
            max-width: 80% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HomePage;
